export default "__VITE_ASSET__DET6rcRR__"